import { SET_SELECTED_TABLE } from './types';


export function setSelectedTable(state) {
    return {
        type: SET_SELECTED_TABLE,
        payload: state
    }
}